import React from 'react'
import { DataTable, TextInput, Button } from '@paypalcorp/pp-react'
import Fuse from 'fuse.js'

// This object is used in the cardSupportedCurrenciesACDC_Focus_Columns array of the SearchableTableACDCNotCollapsed object to format content defined in the cardSupportedCurrenciesACDC_Focus_Rows array.
// CardBrandCell takes an array of card brands and presents them in with commas and line breaks.
// The card brands passed in the array can include HTML-formatted text.
// When CardBrandCell processes a value in the array, the value is returned with a comma and a line break.
// When CardBrandCell processes the last array in value, the value is returned without a comma.
// Note: CardBrandCell doesn't create an HTML list. Elements are separated by a line break.

interface ICellType {
  value: string[]
}

const CardBrandCell = ({ value }: ICellType) => {
  return (
    <>
      {value.map((brand: string, i: number) => (
        <span key={`cardbrand-${brand}-${i}`}>
          {i === value.length - 1 ? (
            <span>{brand}</span>
          ) : (
            <>
              <span>{brand},</span>
              <br />
            </>
          )}
        </span>
      ))}
    </>
  )
}

export default CardBrandCell
